export default "__VITE_ASSET__DGuHtStu__"